export const newCarData = {
  manufacture: "",
  registerdate:new Date(),
  make: {},
  modal: {},
  variant: {},
  fule: {},
  rto: {},
  manufactureErr: "unchecked",
  makeErr: "unchecked",
  modalErr: "unchecked",
  variantErr: "unchecked",
  fuleErr: "unchecked",
  rtoErr: "unchecked",
};

export const handelChange = (state, action) => {
  switch (action.type) {
    case "input": {
      const alphaNumberLengthRegex = new RegExp(`${action?.regex}`);
      return {
        ...state,
        [action.name]: action.value,
        [action.name + "Err"]: alphaNumberLengthRegex.test(action.value?.trim())
          ? "success"
          : action.value === ""
          ? "unchecked"
          : "error",
      };
    }

    case "Select": {
      return {
        ...state,
        [action.name]: action.value || "",
        [action.name + "Err"]: action.value ? "success" : "error",
      };
    }

    case "file": {
      return {
        ...state,
        [action.name]: action.value || "",
        [action.name + "Err"]: action.value ? "success" : "error",
      };
    }

    case "bulkUpdate": {
      const updatedState = { ...state };
      Object.keys(action.payload).forEach((key) => {
        updatedState[key] = action.payload[key];
        if (key.endsWith("Err")) {
          updatedState[key] = "success"; 
        } else {
          updatedState[`${key}Err`] = action.payload[key] ? "success" : "error";
        }
      });

      return updatedState;
    }

    default:
      return state;
  }
};